import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import AsyncSelect from 'react-select/async';
import { audiencesApi } from '../../../api/audiences';
import ListIcon from '../../../assets/icons/custom_list.svg';
import SegmentIcon from '../../../assets/icons/segment.svg';
import { debounce } from '../../../utils/debounce';
import { placeholderStyle } from '../../AddSegment/Condition/Condition.constants';
import {
  MultiValueLabel,
  MultiValueRemove,
} from '../../AddSegment/components/labels';
import styles from '../Contacts.module.scss';

const getIcon = (type) => {
  switch (type) {
    case 'list':
      return <ListIcon height={14} width={14} />;
    case 'segment':
      return <SegmentIcon height={14} width={14} />;
    default:
      return null;
  }
};

const getOptionLabel = (option) => (
  <div className={styles.option_label_wrapper}>
    <span className={styles.option_label_icon}>{getIcon(option.type)}</span>
    <span>{option.label}</span>
  </div>
);

const Audiences = ({ audiences, setAudiences, isLoading }) => {
  const dispatch = useDispatch();

  const loadOptions = useCallback(
    async (inputValue) => {
      try {
        const segmentsPromise = dispatch(
          audiencesApi.endpoints.getSegmentOptions.initiate(
            {
              search: inputValue,
            },
            {
              forceRefetch: true,
            }
          )
        ).unwrap();

        const listsPromise = dispatch(
          audiencesApi.endpoints.getListOptions.initiate(
            {
              search: inputValue,
            },
            {
              forceRefetch: true,
            }
          )
        ).unwrap();

        const [segmentsApiResult, listsApiResult] = await Promise.all([
          segmentsPromise,
          listsPromise,
        ]);

        const segments = segmentsApiResult.map((item) => ({
          value: item.id,
          label: item.name,
          type: 'segment',
        }));

        const lists = listsApiResult.map((item) => ({
          value: item.id,
          label: item.name,
          type: 'list',
        }));

        const combined = [...segments, ...lists].sort((a, b) =>
          a.label.localeCompare(b.label)
        );
        return combined;
      } catch (error) {
        return [];
      }
    },
    [dispatch]
  );

  const debouncedLoadOptions = useMemo(
    () => debounce(loadOptions, 1000),
    [loadOptions]
  );

  return (
    <div className={styles.filter_row}>
      <span className={styles.label}>Audiences</span>

      <AsyncSelect
        styles={placeholderStyle}
        maxMenuHeight={194}
        components={{
          // eslint-disable-next-line react/no-unstable-nested-components
          MultiValueRemove: (props) => (
            <MultiValueRemove props={props} show="label" />
          ),
          // eslint-disable-next-line react/no-unstable-nested-components
          MultiValueLabel: (props) => (
            <MultiValueLabel props={props} show="label" />
          ),
        }}
        className="w-100"
        value={audiences}
        loadOptions={debouncedLoadOptions}
        isSearchable
        onChange={(newValue) => {
          setAudiences(newValue);
        }}
        isLoading={isLoading}
        getOptionLabel={getOptionLabel}
        defaultOptions
        cacheOptions
        isShowValue
        isMulti
      />
    </div>
  );
};
export default Audiences;
